import { createApi } from '@reduxjs/toolkit/query/react'
import { appPortalBaseQuery } from '@/features/baseQuery.ts'
import { ColumnState } from 'ag-grid-community'

export interface AgGridStateDto {
  gridId: string
  columnState: ColumnState[] | null
  filterModel: Record<string, unknown> | null
  sortModel: { colId: string; sort: string }[] | null
}

const USER_PREFERENCE_URL = 'api/user-grid-configs'

export const agGridStateApi = createApi({
  reducerPath: 'agGridStateApi',
  baseQuery: appPortalBaseQuery(),
  tagTypes: ['AgGridState'],
  endpoints: builder => ({
    getAgGridState: builder.query<AgGridStateDto, string>({
      query: (gridId) => ({
        url: `${USER_PREFERENCE_URL}/${gridId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, gridId) => [{ type: 'AgGridState', id: gridId }],
    }),
    saveAgGridState: builder.mutation<void, AgGridStateDto>({
      query: (body) => ({
        url: `${USER_PREFERENCE_URL}/${body.gridId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, { gridId }) => [{ type: 'AgGridState', id: gridId }],
    }),
  }),
})

export const { useGetAgGridStateQuery, useSaveAgGridStateMutation } = agGridStateApi
